'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AbstractReactComponent = require('../AbstractReactComponent');

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./PageWrapper.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Komponenta pro vlastní obsah stránky.
 * Komponenta podporuje sekce: leftPanel, rightPanel, které jsou předávány přes props, levý a pravý může být typu zasouvací.
 * Komponenta podporuje center panel, který je předáván jako children.
 */
// ---
var PageWrapper = function (_AbstractReactCompone) {
    (0, _inherits3.default)(PageWrapper, _AbstractReactCompone);

    function PageWrapper() {
        (0, _classCallCheck3.default)(this, PageWrapper);
        return (0, _possibleConstructorReturn3.default)(this, (PageWrapper.__proto__ || (0, _getPrototypeOf2.default)(PageWrapper)).apply(this, arguments));
    }

    (0, _createClass3.default)(PageWrapper, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                children = _props.children,
                leftPanel = _props.leftPanel,
                rightPanel = _props.rightPanel;


            var wrapperClassNames = (0, _classnames2.default)(className, "page-wrapper", {
                "has-left-panel": leftPanel ? true : false,
                "has-right-panel": rightPanel ? true : false
            });

            return _react2.default.createElement(
                'div',
                { className: wrapperClassNames },
                leftPanel && _react2.default.createElement(
                    'div',
                    { className: 'page-wrapper-left-panel' },
                    leftPanel
                ),
                _react2.default.createElement(
                    'div',
                    { className: "page-wrapper-center-panel" },
                    children
                ),
                rightPanel && _react2.default.createElement(
                    'div',
                    { className: 'page-wrapper-right-panel' },
                    rightPanel
                )
            );
        }
    }]);
    return PageWrapper;
}(_AbstractReactComponent2.default);

PageWrapper.propTypes = {
    leftPanel: _react2.default.PropTypes.oneOfType([// pokud je uvedeno, obsahuje obsah levého panelu, pokud není uvedeno, levý panel se vůbec nezobrazí
    _react2.default.PropTypes.array, _react2.default.PropTypes.node]),
    rightPanel: _react2.default.PropTypes.oneOfType([// pokud je uvedeno, obsahuje obsah pravého panelu, pokud není uvedeno, pravý panel se vůbec nezobrazí
    _react2.default.PropTypes.array, _react2.default.PropTypes.node])
};
PageWrapper.defaultProps = {};
exports.default = PageWrapper;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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